import template from './cashbox.html';
import controller from './cashbox.controller';

let cashboxComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default cashboxComponent;
